import { createStore, applyMiddleware, compose } from "redux"
import socketMiddleware from "./middlewares"
import thunk from "redux-thunk"
import logger from "redux-logger"
import combineReducers from "./reducers/index"

const isBrowser = typeof window !== 'undefined';

const saveToLocalStorage = (state) => {
  if (!isBrowser) return;
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem("state", serializedState)
  } catch (e) {
    console.log(e)
  }
}

const loadFromLocalStorage = () => {
  if (!isBrowser) return undefined;
  try {
    const serializedState = localStorage.getItem("state")
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch (e) {
    console.log(e)
    return undefined
  }
}

const composeEnhancers = (isBrowser && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
const persistedState = loadFromLocalStorage();
const middleWares = (isBrowser && ["production"].includes(window.REACT_APP_PWA_APP_ENV))
  ? applyMiddleware(socketMiddleware(), thunk)
  : applyMiddleware(socketMiddleware(), thunk, logger);

const store = createStore(
  combineReducers,
  persistedState,
  composeEnhancers(middleWares),
)

if (isBrowser) {
  store.subscribe(() => saveToLocalStorage(store.getState()))
}

export default store
